import React, { useState } from 'react';
import css from './SectionTalentHero.module.css';
import { Icons } from '../../../../components';
import { FormattedMessage } from 'react-intl';
import SubscriptionPaymentModal from '../../../SubscriptionPage/SubscriptionPaymentModal';
import { getUserType } from '../../../../util/userDataExtraction';
import { createResourceLocatorString } from '../../../../util/routes';
import { getTransactionProcessAlias } from '../../../../util/listingDataExtraction';
import { useSelector } from 'react-redux';
import { fetchMessageTxnInProgress } from '../../ListingPage.duck';

const DirectChatSection = ({
  directMessageService,
  currentUser,
  listingId,
  directChatTransactionId,
  history,
  routeConfiguration,
  listing,
  isAuthenticated,
  navigateToLogin,
  setChatPurchaseModalState,
}) => {
  const processAlias = getTransactionProcessAlias(listing);
  const fetchTxnInProgress = useSelector(fetchMessageTxnInProgress);

  const userType = getUserType(currentUser);
  const [paymentModalState, setPaymentModalState] = useState(null);
  const openChatPurchaseModal = () => {
    setChatPurchaseModalState({
      priceAmount: directMessageService?.price || 0,
      itemName: directMessageService?.service || '',
      listingId,
    });
  };

  const handleChatClick = () => {
    try {
      // Early return for unauthenticated users
      if (!isAuthenticated) {
        navigateToLogin();
      }

      // Route to order details or payment modal
      const targetUrl = directChatTransactionId
        ? createResourceLocatorString('OrderDetailsPage', routeConfiguration, {
            id: directChatTransactionId,
          })
        : null;

      if (targetUrl) {
        history.push(targetUrl);
      } else {
        openChatPurchaseModal();
      }
    } catch (error) {}
  };
  return (
    <>
      <button type="button" onClick={handleChatClick} disabled={fetchTxnInProgress}>
        <Icons name="messageBox" />
        <FormattedMessage id="SectionHero.chat" />
      </button>
      {paymentModalState?.priceAmount && (
        <SubscriptionPaymentModal
          isOpen={!!paymentModalState?.priceAmount}
          setPaymentMethodModalState={setPaymentModalState}
          selectedPlanId={null}
          selectedPlanName={null}
          subscriptionType={null}
          currentUser={currentUser}
          activeSubscriptionPlanId={null}
          shouldUpdate={false}
          subscriptionId={null}
          userType={userType}
          setIsConfirmationModalOpen={() => {
            setPaymentModalState(null);
          }}
          paymentModalState={paymentModalState}
          processAlias={processAlias}
          isDirectMessageService
        />
      )}
    </>
  );
};

export default DirectChatSection;
